import { createTheme } from "@mui/material/styles";

export const themeColor: any = {
  Primary: "#59CE90",
  Primary600: "#47A573",
};
export const primaryColor: string = "#59CE90";

export const progressBarColor = {
  500: "#F0C253",
  600: "#76AAF5",
  700: "#C2815D",
};

export const green = {
  50: "#FAFEFC",
  100: "#EFFCF5",
  200: "#DCFFED",
  300: "#B8FCD9",
  400: "#92E8BB",
  500: "#59CE90",
  600: "#47A573",
  700: "#357C56",
  800: "#285D41",
  900: "#1F4832",
};

export const neutral = {
  50: "#FAFBFD",
  100: "#F5F7FA",
  200: "#EAEEF4",
  300: "#D7DFE9",
  400: "#AFBACA",
  500: "#8897AE",
  600: "#596981",
  700: "#3D4A5C",
  800: "#2D3643",
  900: "#1D2025",
};

export const success = {
  500: "#70a268",
  300: "#B9D6B4",
  100: "#EEF6ED",
};
export const warn = {
  500: "#F4B64F",
  300: "#FFDB9E",
  100: "#FDF8E8",
};

export const error = {
  500: "#D96A61",
  300: "#FFC4BF",
  100: "#FBEEF1",
};
export const info = {
  500: "#4BA6EE",
  300: "#BDE3F9",
  100: "#E9F5FD",
};
export const theme = createTheme({
  palette: {
    primary: green,
    grey: neutral,
    error: error,
    warning: warn,
    info: info,
    success: success,
  },
});
